import React, { useEffect } from 'react'
import Hero from './screens/Hero'
import SecurityAndPrivacy from './screens/SecurityAndPrivacy'
import OurTechnologies from './screens/OurTechnologies'
import ImageGridThree from './screens/ImageGridThree'
import RoadmapList from './screens/RoadmapList'
import AppStoreRating from './screens/AppStoreRating'
import ReviewSlider from './screens/ReviewSlider'
import { saveFbcToLocalStorage } from '@/helpers/queryParams'
import { useSearchParams } from 'react-router-dom'
import { trackPageView, trackViewContent } from '@/helpers/facebookPixelEvents'
import HeroBrand from '@/components/screens/brand/HeroBrand'
import SecurityAndPrivacyBrand from './screens/brand/SecurityAndPrivacyBrand'
import WhatYouGetBrand from './screens/brand/WhatYouGetBrand'
import WhatYouGet from './screens/WhatYouGet'
import OurTechnologiesBrand from './screens/brand/OurTechnologiesBrand'
import ReviewSliderBrand from './screens/brand/ReviewSliderBrand'
import ImageGridThreeBrand from './screens/brand/ImageGridThreeBrand'
import RoadmapListBrand from './screens/brand/RoadmapListBrand'
import AppStoreRatingBrand from './screens/brand/AppStoreRating'

export const Intro = ({ isWhitePage, version }: { isWhitePage?: boolean; version?: string }) => {
  const [searchParams] = useSearchParams()
  const title = searchParams.get('headline') ?? ''

  useEffect(() => {
    localStorage.setItem('isWhitePage', isWhitePage ? 'true' : 'false')
    saveFbcToLocalStorage(searchParams)
    trackPageView()
    trackViewContent()
  }, [])

  return (
    <>
      {version === 'brand' ? (
        <>
          <HeroBrand title={title} isWhitePage={isWhitePage} />
          <SecurityAndPrivacyBrand />
          <WhatYouGetBrand />
          <OurTechnologiesBrand isWhitePage={isWhitePage} />
          <ReviewSliderBrand isWhitePage={isWhitePage} />
          <ImageGridThreeBrand />
          <RoadmapListBrand isWhitePage={isWhitePage} />
          <AppStoreRatingBrand />
        </>
      ) : (
        <>
          <Hero title={title} isWhitePage={isWhitePage} />
          <SecurityAndPrivacy />
          <WhatYouGet />
          <OurTechnologies isWhitePage={isWhitePage} />
          <ReviewSlider />
          <ImageGridThree />
          <RoadmapList isWhitePage={isWhitePage} />
          <AppStoreRating isWhitePage={true} />
        </>
      )}
    </>
  )
}
